import { createUseStyles } from '@glu/theming';
import '../themeDefaults';

export default createUseStyles(({ nav: { horiz } }) => ({
  root: {
    background: horiz.backgroundGradient || horiz.backgroundColor,
    borderBottomWidth: horiz.borderBottomWidth,
    borderBottomStyle: 'solid',
    borderBottomColor: horiz.backgroundColor,
    '&:after': {
      content: '""',
      display: 'table',
      clear: 'both'
    }
  },
  rightRegion: {
    float: 'left'
  },
  leftRegion: {
    float: 'right'
  },
  left: { float: 'left', paddingLeft: 16 },
  right: { float: 'right', paddingRight: 16 },
  header: {
    float: 'left',
    '&:after': {
      content: '""',
      display: 'table',
      clear: 'both'
    }
  },
  logo: {
    float: 'left',
    '& img': {
      height: 28,
      margin: [12, 16],
      display: 'block'
    },
    '& svg': {
      height: '100%',
      margin: [11, 0, 9, 0]
    }
  },
  'primaryLogo-0': ({ logoBreakpoint }) => ({
    display: 'block',
    [`@media (max-width: ${logoBreakpoint}px)`]: {
      display: 'none'
    }
  }),
  'primaryLogo-1': ({ logoBreakpoint }) => ({
    display: 'none',
    [`@media (max-width: ${logoBreakpoint}px)`]: {
      display: 'block',
      '& img': {
        margin: [12, 16, 12, 0]
      }
    }
  }),
  'secondaryLogo-0': ({ logoBreakpoint }) => ({
    display: 'block',
    [`@media (max-width: ${logoBreakpoint}px)`]: {
      display: 'none'
    }
  }),
  'secondaryLogo-1': ({ logoBreakpoint }) => ({
    display: 'none',
    [`@media (max-width: ${logoBreakpoint}px)`]: {
      display: 'block',
      '& img': {
        margin: [12, 16, 12, 0]
      }
    }
  }),
  logoDivider: {
    position: 'relative',
    '&::after': {
      content: '""',
      opacity: 0.5,
      width: 1,
      height: 18,
      position: 'absolute',
      top: '50%',
      marginTop: -10,
      right: -1,
      marginLeft: horiz.tier0.linkPadding,
      background: horiz.tier0.linkDividerColor
    }
  },
  primaryNav: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    float: 'left'
  },
  secondaryNav: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    float: 'left',
    '& a:hover , & a:focus': {
      background: 'transparent'
    },
    '& >li > a:before': {
      borderRadius: '50%',
      background: 'transparent',
      content: '""',
      display: 'inline-block',
      width: 34,
      height: 34,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    '& a:hover:before, a:focus:before': {
      background: horiz.tier0.linkHoverBackground
    }

  },
  userMenu: {
    float: 'left'
  }
}));
